/** Escapes a value for use in a hand-built query string, so `&`, `#`, `+` and spaces can't corrupt the request. */
export const encodeParam = (value: unknown): string => encodeURIComponent(String(value));
